import type { SearchState } from '@shared/core/search';
import type { ReactNode } from 'react';

export function searchStateText(state: SearchState | 'loading', fallback: ReactNode): ReactNode {
  if (state === 'unavailable') return 'Search is unavailable — try again';
  if (state === 'forbidden') return 'Not available for your role';
  return fallback;
}
